import React, { useEffect } from 'react';
import EventEmitter from 'react-native-eventemitter';
import WeekReport from '../../../components/Report/WeekReport';
import { useParams } from 'react-router-dom';

export default function Report(props) {
  const { week, year, start } = useParams();
  useEffect(() => {
    const callback = (data) => {
      data.route(props.history);
    };
    EventEmitter.on('changeMainRoute', callback);
    window.loader.show();
    return () => {
      EventEmitter.removeListener('changeMainRoute', callback);
    };
  }, []);
  return (
    <div className="week-report-container" style={{ background: '#FFFFFF' }}>
      <WeekReport year={year} week={week} start={start} />
    </div>
  );
}
